import { find as _find, forEach as _forEach, isInteger as _isInteger, isObject as _isObject } from 'lodash';

import { getCarRentalPath } from 'helpers/intl';

export const getSystemTypes = messages => {
  return [
    { label: messages.none, value: null },
    { label: 'Home', value: 'home' },
    { label: messages.login, value: 'login' },
    { label: messages.signup, value: 'signup' },
    { label: messages.imprint, value: 'imprint' },
    { label: messages.contact, value: 'contact' },
    { label: messages.locations, value: 'locations' },
    { label: messages.privacy_policy, value: 'privacy_policy' },
    { label: messages.terms_of_service, value: 'terms_of_service' },
    { label: messages.rental_terms_of_service, value: 'rental_terms_of_service' },
    { label: messages.car_sales_terms_of_service, value: 'car_sales_terms_of_service' },
    { label: messages.item_sales_terms_of_service, value: 'item_sales_terms_of_service' },
    { label: messages.car_rental_form, value: 'reservation' },
    { label: messages.cancellation_policy, value: 'cancellation_policy' },
    { label: messages.marketplace_terms, value: 'marketplace_terms' },
    { label: messages.online_appointment_booking, value: 'online_appointment_booking' },
    { label: messages.order_processing_contract, value: 'order_processing_contract' },
  ];
};

export const getSystemTypeLabel = (value, messages) => {
  const res = _find(getSystemTypes(messages), { value });
  return (res && res.label) || '-';
};

export const getSystemTypeIcon = systemType => {
  switch (systemType) {
    case 'home':
      return 'fa fa-fw fa-home';

    case 'imprint':
      return 'fa fa-fw fa-copyright';

    case 'marketplace_terms':
    case 'rental_terms_of_service':
    case 'car_sales_terms_of_service':
    case 'item_sales_terms_of_service':
    case 'terms_of_service':
    case 'order_processing_contract':
      return 'fa fa-fw fa-gavel';

    case 'privacy_policy':
      return 'fa fa-fw fa-eye-slash';

    case 'cookie_use':
      return 'fas fa-fw fa-bookmark';

    case 'login':
      return 'fa fa-fw fa-lock';

    case 'signup':
      return 'fa fa-fw fa-pencil-alt';

    case 'reservation':
      return 'far fa-fw fa-calendar-alt';

    case 'contact':
      return 'far fa-fw fa-envelope';

    case 'cancellation_policy':
      return 'fas fa-angle-double-left';

    case 'online_appointment_booking':
      return 'fal fa-calendar-check';

    case 'locations':
      return 'fal fa-map-marked';

    case 'registration_success':
      return 'fal user-check';
  }
};

export const getSystemTypeUrl = systemType => {
  const urls = {
    home: '',
    imprint: 'imprint',
    terms_of_service: 'terms',
    privacy_policy: 'privacy',
    cookie_use: 'cookie',
    login: 'login',
    signup: 'signup',
    reservation: 'reservation',
    contact: 'contact',
    locations: 'locations',
    cancellation_policy: 'cancellationPolicy',
    rental_terms_of_service: 'rentTerms',
    online_appointment_booking: 'car-service',
    marketplace_terms: 'termsofuse',
    order_processing_contract: 'orderprocessingcontract',
  };

  return urls[systemType];
};

export const getTemplateTypes = messages => {
  return [
    { label: 'Home', icon: getSystemTypeIcon('home'), value: 'home' },
    { label: messages.login, icon: getSystemTypeIcon('login'), value: 'login' },
    { label: messages.signup, icon: getSystemTypeIcon('signup'), value: 'signup' },
    { label: messages.imprint, icon: getSystemTypeIcon('imprint'), value: 'imprint' },
    { label: messages.contact, icon: getSystemTypeIcon('contact'), value: 'contact' },
    { label: messages.locations, icon: getSystemTypeIcon('locations'), value: 'locations' },
    { label: messages.car_rental_form, icon: getSystemTypeIcon('reservation'), value: 'reservation' },
    {
      label: messages.online_appointment_booking,
      icon: getSystemTypeIcon('online_appointment_booking'),
      value: 'online_appointment_booking',
    },
  ];
};

export const getTemplateType = (typeId, messages) => {
  const types = getTemplateTypes(messages);
  const type = _find(types, ['value', typeId]);
  return type;
};

export const getCmsDataTree = obj => {
  const keys = [
    'type',
    'content',
    'language',
    'props',
    'children',
    'params',
    'name',
    'value',
    'dynamicElementContent',
    'dynamic_element_content',
  ];
  const res = [];

  _forEach(obj, (elem, key) => {
    if (elem && (keys.indexOf(key) > -1 || _isInteger(key))) {
      if (_isObject(elem)) {
        res[key] = getCmsDataTree(elem);
      } else {
        res[key] = elem;
      }
    }
  });

  return res;
};

export const getElementTypes = messages => {
  return [
    { label: messages.call_to_action, value: 'call_to_action' },
    { label: messages.contact, value: 'contacts' },
    { label: 'Content', value: 'contents' },
    { label: messages.features, value: 'features' },
    { label: messages.forms, value: 'forms' },
    { label: messages.headers, value: 'headers' },
    { label: messages.pricings, value: 'pricings' },
    { label: messages.teams, value: 'teams' },
    { label: messages.testimonials, value: 'testimonials' },
  ];
};

export const getElementType = (typeId, messages) => {
  const types = getElementTypes(messages);
  const type = _find(types, ['value', typeId]);
  return type;
};
